module.exports = __webpack_public_path__ + "media/images/dashboard/app_portrait-b10cf5dc86fe9ad29b41c8e780532056de2bd0d19151f71cad42c1652c2a4f46.png";